import "../styles/TipoB.css";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
  FaArrowLeft,
  FaArrowRight,
  FaBath,
  FaBed,
  FaCalendarDays,
  FaCar,
  FaCheck,
  FaCouch,
  FaDoorOpen,
  FaKitchenSet,
  FaRulerCombined,
  FaShirt,
  FaSun,
} from "react-icons/fa6";

import imagenTipoB from "../assets/proyecto3.jpg";

const whatsappLink =
  "https://wa.me/18299623399?text=Hola%2C%20me%20interesa%20recibir%20más%20información%20sobre%20el%20Apartamento%20Tipo%20B%20de%20Residencial%20YANNA%20I.";

const estadisticas = [
  {
    icono: <FaRulerCombined />,
    numero: "129.67",
    unidad: "m²",
    texto: "Área total",
  },
  {
    icono: <FaBed />,
    numero: "3",
    unidad: "",
    texto: "Habitaciones",
  },
  {
    icono: <FaBath />,
    numero: "2.5",
    unidad: "",
    texto: "Baños",
  },
  {
    icono: <FaCar />,
    numero: "12.5",
    unidad: "m²",
    texto: "Área de parqueo",
  },
];

const especificaciones = [
  {
    numero: "01",
    icono: <FaBed />,
    titulo: "Tres habitaciones",
    descripcion:
      "Dormitorios diseñados para ofrecer comodidad, privacidad y una excelente distribución interior.",
  },
  {
    numero: "02",
    icono: <FaBath />,
    titulo: "Dos baños y medio",
    descripcion:
      "Una configuración funcional que aporta mayor practicidad y comodidad para la familia.",
  },
  {
    numero: "03",
    icono: <FaCouch />,
    titulo: "Sala espaciosa",
    descripcion:
      "Un ambiente social acogedor y elegante, ideal para compartir y recibir visitas.",
  },
  {
    numero: "04",
    icono: <FaKitchenSet />,
    titulo: "Cocina moderna",
    descripcion:
      "Cocina bien distribuida, práctica y conectada con las áreas principales del apartamento.",
  },
  {
    numero: "05",
    icono: <FaSun />,
    titulo: "Balcón integrado",
    descripcion:
      "Un espacio que aporta ventilación, iluminación natural y una sensación más abierta.",
  },
  {
    numero: "06",
    icono: <FaShirt />,
    titulo: "Área de lavado",
    descripcion:
      "Zona independiente para las tareas del hogar, integrada con funcionalidad y discreción.",
  },
  {
    numero: "07",
    icono: <FaDoorOpen />,
    titulo: "Distribución eficiente",
    descripcion:
      "Cada espacio fue pensado para aprovechar al máximo cada metro del apartamento.",
  },
  {
    numero: "08",
    icono: <FaCar />,
    titulo: "Parqueo privado",
    descripcion:
      "Área de parqueo con 12.5 m² diseñada para brindar mayor comodidad y seguridad.",
  },
];

const revelar = {
  oculto: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.85,
      ease: "easeOut",
    },
  },
};

function TipoB() {
  return (
    <main className="tipoBPremium">
      {/* HERO */}

      <section className="tipoBPremiumHero">
        <div className="tipoBPremiumHeroGlow tipoBPremiumHeroGlowOne"></div>
        <div className="tipoBPremiumHeroGlow tipoBPremiumHeroGlowTwo"></div>

        <motion.div
          className="tipoBPremiumHeroContainer"
          initial={{ opacity: 0, y: 45 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.95,
            ease: "easeOut",
          }}
        >
          <Link to="/" className="tipoBPremiumBack">
            <FaArrowLeft />
            Volver
          </Link>

          <div className="tipoBPremiumEyebrow">
            <span></span>
            ELEGANCIA Y FUNCIONALIDAD
            <span></span>
          </div>

          <h1>
            Apartamento
            <strong>Tipo B</strong>
          </h1>

          <p className="tipoBPremiumHeroDescription">
            Una propuesta residencial sofisticada, pensada para quienes
            desean un apartamento amplio, funcional y con una imagen
            moderna dentro de Residencial YANNA I.
          </p>

          <p className="tipoBPremiumHeroDescriptionSecondary">
            Sus 129.67 m² integran áreas sociales bien conectadas, tres
            habitaciones, excelente iluminación y una distribución que
            aprovecha cada espacio con armonía.
          </p>

          <div className="tipoBPremiumPricePanel">
            <div className="tipoBPremiumPriceItem">
              <span>PRECIO DE VENTA</span>
              <strong>US$174,017.14</strong>
            </div>

            <div className="tipoBPremiumPriceDivider"></div>

            <div className="tipoBPremiumPriceItem">
              <span>MONTO DE RESERVA</span>
              <strong>US$5,000</strong>
            </div>
          </div>

          <div className="tipoBPremiumHeroButtons">
            <Link
              to="/reserva"
              className="tipoBPremiumButton tipoBPremiumButtonPrimary"
            >
              Reservar apartamento
              <FaArrowRight />
            </Link>

            <Link
              to="/reserva"
              className="tipoBPremiumButton tipoBPremiumButtonSecondary"
            >
              <FaCalendarDays />
              Agendar una visita
            </Link>
          </div>

          <p className="tipoBPremiumReservationNote">
            Unidad disponible con una reserva inicial de
            <strong> US$5,000.</strong>
          </p>
        </motion.div>
      </section>

      {/* ESTADÍSTICAS */}

      <section className="tipoBPremiumStats">
        <div className="tipoBPremiumStatsContainer">
          {estadisticas.map((item, index) => (
            <motion.article
              key={item.texto}
              className="tipoBPremiumStatCard"
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{
                duration: 0.55,
                delay: index * 0.1,
              }}
              whileHover={{ y: -9 }}
            >
              <div className="tipoBPremiumStatIcon">
                {item.icono}
              </div>

              <div className="tipoBPremiumStatValue">
                <strong>{item.numero}</strong>
                {item.unidad && <span>{item.unidad}</span>}
              </div>

              <p>{item.texto}</p>
            </motion.article>
          ))}
        </div>
      </section>

      {/* UNA SOLA IMAGEN */}

      <section className="tipoBPremiumShowcase">
        <motion.div
          className="tipoBPremiumShowcaseHeader"
          variants={revelar}
          initial="oculto"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <span>VISTA DESTACADA</span>

          <h2>
            Una distribución que aprovecha cada metro.
          </h2>

          <p>
            Una sola perspectiva para resaltar la amplitud, la
            distribución inteligente y el estilo contemporáneo del
            Apartamento Tipo B.
          </p>
        </motion.div>

        <motion.div
          className="tipoBPremiumPhotoPerspective"
          initial={{ opacity: 0, y: 60, scale: 0.96 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, amount: 0.18 }}
          transition={{
            duration: 1,
            ease: "easeOut",
          }}
        >
          <motion.figure
            className="tipoBPremiumPhotoCard"
            initial={{ rotateY: -4, rotateX: 2 }}
            whileHover={{
              rotateY: 2,
              rotateX: 0,
              y: -12,
              scale: 1.015,
            }}
            transition={{
              duration: 0.45,
              ease: "easeOut",
            }}
          >
            <div className="tipoBPremiumPhotoGoldFrame"></div>
            <div className="tipoBPremiumPhotoCorner tipoBPremiumPhotoCornerTop"></div>

            <img
              src={imagenTipoB}
              alt="Vista 3D del Apartamento Tipo B"
            />

            <div className="tipoBPremiumPhotoGradient"></div>

            <figcaption className="tipoBPremiumPhotoCaption">
              <div>
                <span>PLANO ARQUITECTÓNICO</span>
                <strong>Apartamento Tipo B</strong>
              </div>

              <div className="tipoBPremiumPhotoMeta">
                <span>129.67 m²</span>

                <span className="tipoBPremiumAvailable">
                  <i></i>
                  Disponible
                </span>
              </div>
            </figcaption>
          </motion.figure>
        </motion.div>
      </section>

      {/* TEXTO ELEGANTE SIN MÁS IMÁGENES */}

      <section className="tipoBPremiumSignature">
        <motion.div
          className="tipoBPremiumSignatureContent"
          variants={revelar}
          initial="oculto"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <span className="tipoBPremiumSectionLabel">
            RESIDENCIA CONTEMPORÁNEA
          </span>

          <h2>
            Una residencia pensada para vivir con equilibrio y estilo.
          </h2>

          <div className="tipoBPremiumSignatureDivider"></div>

          <p className="tipoBPremiumSignatureLead">
            El Apartamento Tipo B ofrece una combinación equilibrada
            entre áreas sociales y privadas. La sala, el comedor y la
            cocina crean un ambiente conectado, mientras las
            habitaciones conservan la privacidad necesaria para el
            descanso.
          </p>

          <p>
            Su balcón aporta ventilación e iluminación natural,
            convirtiéndose en un espacio agradable para iniciar el día,
            compartir una conversación o simplemente disfrutar de la
            tranquilidad del entorno.
          </p>

          <div className="tipoBPremiumSignatureChecks">
            <div>
              <FaCheck />
              <span>Diseño contemporáneo</span>
            </div>

            <div>
              <FaCheck />
              <span>Distribución eficiente</span>
            </div>

            <div>
              <FaCheck />
              <span>Ambientes iluminados</span>
            </div>

            <div>
              <FaCheck />
              <span>Terminaciones elegantes</span>
            </div>
          </div>
        </motion.div>
      </section>

      {/* ESPECIFICACIONES */}

      <section className="tipoBPremiumSpecifications">
        <motion.div
          className="tipoBPremiumSpecificationsHeader"
          variants={revelar}
          initial="oculto"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <span>CARACTERÍSTICAS DESTACADAS</span>

          <h2>
            Espacios creados para sentirse en casa con elegancia.
          </h2>

          <p>
            Cada área fue diseñada para ofrecer comodidad, fluidez y una
            experiencia residencial atractiva dentro de un formato
            práctico y bien distribuido.
          </p>
        </motion.div>

        <div className="tipoBPremiumSpecificationsGrid">
          {especificaciones.map((item, index) => (
            <motion.article
              key={item.titulo}
              className="tipoBPremiumSpecificationCard"
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.55,
                delay: index * 0.06,
              }}
              whileHover={{ y: -8 }}
            >
              <span className="tipoBPremiumSpecificationNumber">
                {item.numero}
              </span>

              <div className="tipoBPremiumSpecificationIcon">
                {item.icono}
              </div>

              <h3>{item.titulo}</h3>

              <p>{item.descripcion}</p>
            </motion.article>
          ))}
        </div>
      </section>

      {/* INVERSIÓN */}

      <section className="tipoBPremiumInvestment">
        <div className="tipoBPremiumInvestmentGlow"></div>

        <motion.div
          className="tipoBPremiumInvestmentContent"
          variants={revelar}
          initial="oculto"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <span>INVERSIÓN RESIDENCIAL</span>

          <h2>
            Un apartamento elegante, funcional y con excelente valor.
          </h2>

          <p>
            El Tipo B es ideal para quienes desean amplitud,
            distribución equilibrada y una propuesta residencial que
            combine comodidad y diseño.
          </p>

          <div className="tipoBPremiumInvestmentDetails">
            <div>
              <span>PRECIO DE VENTA</span>
              <strong>US$174,017.14</strong>
            </div>

            <div>
              <span>RESERVA INICIAL</span>
              <strong>US$5,000</strong>
            </div>
          </div>

          <div className="tipoBPremiumInvestmentButtons">
            <Link
              to="/reserva"
              className="tipoBPremiumInvestmentPrimary"
            >
              Agendar visita privada
              <FaArrowRight />
            </Link>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="tipoBPremiumInvestmentSecondary"
            >
              Hablar con un asesor
            </a>
          </div>
        </motion.div>
      </section>

      {/* CTA FINAL */}

      <section className="tipoBPremiumFinal">
        <div className="tipoBPremiumFinalPattern"></div>

        <motion.div
          className="tipoBPremiumFinalContent"
          initial={{ opacity: 0, y: 45 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.9 }}
        >
          <span>COLECCIÓN RESIDENCIAL YANNA I</span>

          <h2>
            Haz del Apartamento Tipo B tu próxima inversión.
          </h2>

          <p>
            Reserva con US$5,000 y permite que nuestro equipo te
            acompañe para conocer esta unidad y resolver cualquier duda.
          </p>

          <div className="tipoBPremiumFinalButtons">
            <Link
              to="/reserva"
              className="tipoBPremiumFinalPrimary"
            >
              Iniciar mi reserva
              <FaArrowRight />
            </Link>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="tipoBPremiumFinalSecondary"
            >
              Solicitar información
            </a>
          </div>
        </motion.div>
      </section>
    </main>
  );
}

export default TipoB;